export default {
  addNewUserTitle: {
    id: 'bo_seller-profile-user_permission-form-title',
    defaultMessage: 'Add new user',
  },
  addNewUserDetails: {
    id: 'bo_seller-profile-user_permission-form-enter_details',
    defaultMessage: "Enter your new user's details.",
  },
  firstName: {
    id: 'bo_seller-profile-user_permission-form-first_name',
    defaultMessage: 'First name',
  },
  firstNameKanji: {
    id: 'bo_seller-profile-user_permission-form-first_name_kanji',
    defaultMessage: 'Firstname (Kanji)',
  },
  firstNamePronunciation: {
    id: 'bo_seller-profile-user_permission-form-first_name_kana',
    defaultMessage: 'Firstname (Kana - Optional)',
  },
  lastName: {
    id: 'bo_seller-profile-user_permission-form-last_name',
    defaultMessage: 'Last name',
  },
  lastNameKanji: {
    id: 'bo_seller-profile-user_permission-form-last_name_kanji',
    defaultMessage: 'Surnane (Kanji)',
  },
  lastNamePronunciation: {
    id: 'bo_seller-profile-user_permission-form-last_name_kana',
    defaultMessage: 'Surname (Kana - Optional)',
  },
  email: {
    id: 'bo_seller-profile-user_permission-form-email',
    defaultMessage: 'Email address',
  },
  emailInfoLabel: {
    id: 'bo_seller-profile-user_permission-form-email_info_label',
    defaultMessage:
      'This user will log into Back Office with this email address.',
  },
  addNewUserAction: {
    id: 'bo_seller-profile-user_permission-form-add_new_user',
    defaultMessage: 'Add new user',
  },
  editUserAction: {
    id: 'bo_seller-profile-user_permission-form-edit_user',
    defaultMessage: 'Edit user',
  },
  newUserAdded: {
    id: 'bo_seller-profile-user_permission-creation-success_toast_title',
    defaultMessage: 'New user added',
  },
  nextStep: {
    id: 'bo_seller-profile-user_permission-creation-success_toast_content',
    defaultMessage:
      "Next step: they'll receive an email prompting them to activate their account.",
  },
  userEditedTitle: {
    id: 'bo_seller-profile-user_permission-creation-edit_success_toast_title',
    defaultMessage: 'User is edited!',
  },
  userEditedContent: {
    id: 'bo_seller-profile-user_permission-creation-edit_success_toast_content',
    defaultMessage: 'The user information have been correctly updated.',
  },
  required: {
    id: 'bo_seller-profile-user_permission-form-required',
    defaultMessage: 'This field is required',
  },
  invalidEmail: {
    id: 'bo_seller-profile-user_permission-form-invalid_email',
    defaultMessage: 'You should provide a valid email address',
  },
  managePermissions: {
    id: 'bo_seller-profile-user_permission-manage_permissions',
    defaultMessage: 'Manage permissions',
  },
  managePermissionsInfo: {
    id: 'bo_seller-profile-user_permission-manage_permissions_info',
    defaultMessage:
      'Decide which pages this user can access and edit within your Back Office.',
  },
  page: {
    id: 'bo_seller-profile-user_permission-page',
    defaultMessage: 'Page',
  },
  noAccess: {
    id: 'bo_seller-profile-user_permission-no_access',
    defaultMessage: 'No access',
  },
  editingAccess: {
    id: 'bo_seller-profile-user_permission-editing_access',
    defaultMessage: 'Edit',
  },
  noAccessPermission: {
    id: 'bo_seller-profile-user_permission-editing_no_access',
    defaultMessage: 'User cannot access the {pageName} page',
  },
  editPermission: {
    id: 'bo_seller-profile-user_permission-editing_edit_permission',
    defaultMessage: 'User can edit the {pageName} page',
  },
  errorTitle: {
    id: 'bo_seller-profile-user_permission-error_title',
    defaultMessage: 'Oops...',
  },
}
